(() => {
 const enabled = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
 const init = (root = document) => {
  root.querySelectorAll('.header__inline-menu > ul > li > header-menu').forEach(menu => {
   if (menu.dataset.nutraceneHoverReady) return;
   menu.dataset.nutraceneHoverReady = 'true';
   const details = menu.querySelector('details');
   const summary = details?.querySelector('summary');
   if (!details || !summary) return;
   let timer;
   menu.addEventListener('pointerenter', event => {
    if (!enabled.matches || event.pointerType === 'touch') return;
    clearTimeout(timer);
    document.querySelectorAll('.header__inline-menu > ul > li > header-menu > details[open]').forEach(other => {
     if (other === details) return;
     other.open = false;
     other.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });
    details.open = true;
    summary.setAttribute('aria-expanded', 'true');
   });
   menu.addEventListener('pointerleave', () => {
    if (!enabled.matches) return;
    timer = setTimeout(() => {
     if (menu.contains(document.activeElement) && document.activeElement.matches(':focus-visible')) return;
     details.open = false;
     summary.setAttribute('aria-expanded', 'false');
    }, 180);
   });
   details.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(details.open)));
  });
 };
 init();
 document.addEventListener('shopify:section:load', event => init(event.target));
})();
